const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/eCheckin/sections/Kommentar.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import textMap from '../translations';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import cis4mComponentsTextMap from '@cistec/common_web/modules/CIS4m/components/translations';
import _ from 'lodash';
import { validateKommentarField } from '../validation';
import { useText } from '@cistec/common_web/utils/intlUtils';

export const Kommentar = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_KOMMENTAR = createFieldPath(path, 'kommentar');

    const formData = useCIS4mData();
    const kopmmentar = _.get(formData, PATH_KOMMENTAR) || '';

    const kommentarMaxLength = 250;
    const kommentarLength = kopmmentar.length;

    const { formatMessage } = useIntl();
    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <p>{formatMessage(textMap.kommentarSubTitle)}</p>
            <CIS4mTextField
                path={PATH_KOMMENTAR}
                label={textMap.kommentar}
                maxLength={250}
                helperText={formatMessage(cis4mComponentsTextMap.charactersRemaining, {
                    count: kommentarMaxLength - kommentarLength,
                })}
                checkValidity={validateKommentarField}
            />
        </ECheckinSection>
    );
});

Kommentar.displayName = 'Kommentar';

export default Kommentar;
